module.exports = __webpack_public_path__ + "static/media/down-arrow-dis.e55975ab.svg";